// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"appCheckboxField_checkbox__1wAJV"};